export const glossaryKeys = {
  all: ['glossary'] as const,

  glossaryTree: [...(['glossary'] as const), 'glossaryTree'] as const,

  categories: (limit: number) => [...glossaryKeys.all, 'categories', limit] as const,
  categoriesAllPrefix: () => [...glossaryKeys.all, 'categoriesAll'] as const,
  categoriesAll: () => [...glossaryKeys.categoriesAllPrefix()] as const,
  category: (category: string) => [...glossaryKeys.all, 'category', category] as const,
  categoryInfo: (category: string) => [...glossaryKeys.category(category), 'info'] as const,

  termsPrefix: () => [...glossaryKeys.all, 'terms'] as const,
  terms: (directChildrenOf: string) => [...glossaryKeys.termsPrefix(), directChildrenOf] as const,
  termsAllPrefix: () => [...glossaryKeys.all, 'termsAll'] as const,
  termsAll: () => [...glossaryKeys.termsAllPrefix()] as const,
  childTermsPrefix: () => [...glossaryKeys.all, 'childTerms'] as const,
  childTerms: (parentFqn: string) => [...glossaryKeys.childTermsPrefix(), parentFqn] as const,

  termDetail: (category: string, name: string) => [...glossaryKeys.category(category), 'term', name] as const,
  termDetailByFqnPrefix: () => [...glossaryKeys.all, 'termDetailByFqn'] as const,
  termDetailByFqn: (termFqn: string) => [...glossaryKeys.termDetailByFqnPrefix(), termFqn] as const,
  termBasic: (termFqn: string) => [...glossaryKeys.all, 'termBasic', termFqn] as const,

  taggedAssetsPrefix: () => [...glossaryKeys.all, 'taggedAssets'] as const,
  taggedAssets: (termFqn: string, filters?: unknown, query?: string, sortBy?: string, sortOrder?: string) =>
    [...glossaryKeys.taggedAssetsPrefix(), termFqn, filters, query, sortBy, sortOrder] as const,
  taggedAssetsCountPrefix: () => [...glossaryKeys.all, 'taggedAssetsCount'] as const,
  taggedAssetsCount: (termFqn: string) => [...glossaryKeys.taggedAssetsCountPrefix(), termFqn] as const,

  search: (q: string, glossaryFqn: string | undefined, offset: number) =>
    [...glossaryKeys.all, 'search', q, glossaryFqn, offset] as const,
} as const;
